if (!customElements.get('afterpay-messaging')) {
  customElements.define(
    'afterpay-messaging',
    class AfterpayMessaging extends HTMLElement {
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        // Keep the Afterpay amount in sync when the variant is switched on the product page
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.dataset.sectionId || !event.data.variant) return;

          const placement = this.querySelector('afterpay-placement');
          if (placement) placement.dataset.amount = (event.data.variant.price / 100).toFixed(2);
        });
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
      }
    }
  );
}
